var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronArrowRight = function SvgChevronArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.416 2.5 17.389 17.39L1.195 37.5",
    stroke: "#4F4F4F",
    strokeWidth: 3
  })));
};

export { SvgChevronArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAyMSA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNDE2MjkgMi41TDE4LjgwNSAxOS44ODk0TDEuMTk0MzQgMzcuNSIgc3Ryb2tlPSIjNEY0RjRGIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg==";